Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAnimatedGestureHandler = useAnimatedGestureHandler;
var _Hooks = require("./Hooks");
var EventType = {
    UNDETERMINED: 0,
    FAILED: 1,
    BEGAN: 2,
    CANCELLED: 3,
    ACTIVE: 4,
    END: 5
};
var _worklet_15306771428548_init_data = {
    code: "function anonymous(e){const{useWeb,EventType,handlers,context}=this.__closure;const event=useWeb?e.nativeEvent:e;if(event.state===EventType.BEGAN&&handlers.onStart){handlers.onStart(event,context);}if(event.state===EventType.ACTIVE&&handlers.onActive){handlers.onActive(event,context);}if(event.oldState===EventType.ACTIVE&&event.state===EventType.END&&handlers.onEnd){handlers.onEnd(event,context);}if(event.oldState===EventType.BEGAN&&event.state===EventType.FAILED&&handlers.onFail){handlers.onFail(event,context);}if(event.oldState===EventType.ACTIVE&&event.state===EventType.CANCELLED&&handlers.onCancel){handlers.onCancel(event,context);}if((event.oldState===EventType.BEGAN||event.oldState===EventType.ACTIVE)&&event.state!==EventType.BEGAN&&event.state!==EventType.ACTIVE&&handlers.onFinish){handlers.onFinish(event,context,event.state===EventType.CANCELLED||event.state===EventType.FAILED);}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedGestureHandler.ts",
    sourceMap: '{"version":3,"names":["anonymous","e","useWeb","EventType","handlers","context","__closure","event","nativeEvent","state","BEGAN","onStart","ACTIVE","onActive","oldState","END","onEnd","FAILED","onFail","CANCELLED","onCancel","onFinish"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedGestureHandler.ts"],"mappings":"AAwDkB,QAAC,CAAAA,SAASA,CAAAC,CAAA,QAAAC,MAAA,CAAAC,SAAA,CAAAC,QAAA,CAAAC,OAAA,OAAAC,SAAA,CAExB,KAAM,CAAAC,KAAK,CAAGL,MAAM,CAAGD,CAAC,CAACO,WAAW,CAAGP,CAAC,CAExC,GAAIM,KAAK,CAACE,KAAK,GAAKN,SAAS,CAACO,KAAK,EAAIN,QAAQ,CAACO,OAAO,CAAE,CACvDP,QAAQ,CAACO,OAAO,CAACJ,KAAK,CAAEF,OAAO,CAAC,CAClC,CACA,GAAIE,KAAK,CAACE,KAAK,GAAKN,SAAS,CAACS,MAAM,EAAIR,QAAQ,CAACS,QAAQ,CAAE,CACzDT,QAAQ,CAACS,QAAQ,CAACN,KAAK,CAAEF,OAAO,CAAC,CACnC,CACA,GACEE,KAAK,CAACO,QAAQ,GAAKX,SAAS,CAACS,MAAM,EACnCL,KAAK,CAACE,KAAK,GAAKN,SAAS,CAACY,GAAG,EAC7BX,QAAQ,CAACY,KAAK,CACd,CACAZ,QAAQ,CAACY,KAAK,CAACT,KAAK,CAAEF,OAAO,CAAC,CAChC,CACA,GACEE,KAAK,CAACO,QAAQ,GAAKX,SAAS,CAACO,KAAK,EAClCH,KAAK,CAACE,KAAK,GAAKN,SAAS,CAACc,MAAM,EAChCb,QAAQ,CAACc,MAAM,CACf,CACAd,QAAQ,CAACc,MAAM,CAACX,KAAK,CAAEF,OAAO,CAAC,CACjC,CACA,GACEE,KAAK,CAACO,QAAQ,GAAKX,SAAS,CAACS,MAAM,EACnCL,KAAK,CAACE,KAAK,GAAKN,SAAS,CAACgB,SAAS,EACnCf,QAAQ,CAACgB,QAAQ,CACjB,CACAhB,QAAQ,CAACgB,QAAQ,CAACb,KAAK,CAAEF,OAAO,CAAC,CACnC,CACA,GACE,CAACE,KAAK,CAACO,QAAQ,GAAKX,SAAS,CAACO,KAAK,EACjCH,KAAK,CAACO,QAAQ,GAAKX,SAAS,CAACS,MAAM,GACrCL,KAAK,CAACE,KAAK,GAAKN,SAAS,CAACO,KAAK,EAC/BH,KAAK,CAACE,KAAK,GAAKN,SAAS,CAACS,MAAM,EAChCR,QAAQ,CAACiB,QAAQ,CACjB,CACAjB,QAAQ,CAACiB,QAAQ,CACfd,KAAK,CACLF,OAAO,CACPE,KAAK,CAACE,KAAK,GAAKN,SAAS,CAACgB,SAAS,EAAIZ,KAAK,CAACE,KAAK,GAAKN,SAAS,CAACc,MACnE,CAAC,CACH,CACF"}',
    version: "3.5.4"
};
function useAnimatedGestureHandler(handlers, dependencies) {
    var _useHandler = (0, _Hooks.useHandler)(handlers, dependencies), context = _useHandler.context, doDependenciesDiffer = _useHandler.doDependenciesDiffer, useWeb = _useHandler.useWeb;
    var handler = function() {
        var _e = [
            new global.Error(),
            -5,
            -27
        ];
        var anonymous = function anonymous(e) {
            var event = useWeb ? e.nativeEvent : e;
            if (event.state === EventType.BEGAN && handlers.onStart) {
                handlers.onStart(event, context);
            }
            if (event.state === EventType.ACTIVE && handlers.onActive) {
                handlers.onActive(event, context);
            }
            if (event.oldState === EventType.ACTIVE && event.state === EventType.END && handlers.onEnd) {
                handlers.onEnd(event, context);
            }
            if (event.oldState === EventType.BEGAN && event.state === EventType.FAILED && handlers.onFail) {
                handlers.onFail(event, context);
            }
            if (event.oldState === EventType.ACTIVE && event.state === EventType.CANCELLED && handlers.onCancel) {
                handlers.onCancel(event, context);
            }
            if ((event.oldState === EventType.BEGAN || event.oldState === EventType.ACTIVE) && event.state !== EventType.BEGAN && event.state !== EventType.ACTIVE && handlers.onFinish) {
                handlers.onFinish(event, context, event.state === EventType.CANCELLED || event.state === EventType.FAILED);
            }
        };
        anonymous.__closure = {
            useWeb: useWeb,
            EventType: EventType,
            handlers: handlers,
            context: context
        };
        anonymous.__initData = _worklet_15306771428548_init_data;
        anonymous.__workletHash = 15306771428548;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
    if (useWeb) {
        return handler;
    }
    return (0, _Hooks.useEvent)(handler, [
        "onGestureHandlerStateChange",
        "onGestureHandlerEvent"
    ], doDependenciesDiffer);
}
